module.exports = __webpack_public_path__ + "static/media/LogicWedge6_3_drag_3.14f2d6de.png";